import {
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  START_FETCHING,
  GET_AUTHOR_SUCCESS,
  GET_CRAFTSMAN_SUCCESS,
  GET_USERS_BY_ID_SUCCESS,
  ADD_USER_ERROR,
  ADD_USER,
  UPDATE_USER,
} from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
  creating: "creating",
  updating: "updating",
}

const INIT_STATE = {
  data: {},
  dataById: {},
  author: [],
  craftsman: [],
  status: statuslist.idle,
  error: {},
}

const Users = (state = INIT_STATE, action) => {
  switch (action.type) {
    case START_FETCHING:
      return {
        ...state,
        status: statuslist.process,
      }
    case GET_USER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: statuslist.success,
      }
    case GET_USERS_BY_ID_SUCCESS:
      return {
        ...state,
        dataById: action.payload,
      }
    case GET_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        status: statuslist.error,
      }
    case GET_AUTHOR_SUCCESS:
      return {
        ...state,
        author: action.payload,
      }
    case GET_CRAFTSMAN_SUCCESS:
      return {
        ...state,
        craftsman: action.payload,
      }
    case ADD_USER:
      return {
        ...state,
        status: statuslist.creating,
      }
    case UPDATE_USER:
      return {
        ...state,
        status: statuslist.updating,
      }
    case ADD_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        status: statuslist.error,
      }

    default:
      return state
  }
}

export default Users
